<script setup lang="ts">
  const { disabled } = defineProps<{ disabled?: boolean }>();

  const emit = defineEmits<{ (e: "click"): void }>();
</script>

<template>
  <div class="main-page-action" :disabled="disabled || undefined" @click="emit('click')">
    <slot name="icon" />
    <slot name="text" />
  </div>
</template>

<style scoped>
  .main-page-action {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: 16px;
    position: relative;
    gap: 8px;
    background-color: var(--sf-base-background-white);

    & :slotted(.text) {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &[disabled="true"] {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
</style>
